import { RuleResult } from '../../../../types/DeclarationP5'

const C0019Validator = {
  validateSpecificCircumstanceIndicatorRequirement: ({
    security,
  }: {
    security: string
  }): RuleResult => (['1', '3'].includes(security) ? 'REQUIRED' : 'OPTIONAL'),
}

export default C0019Validator
